import { IntroWrapper } from './__intro-elements';
import { IntroKeys } from './intro-keys';

const Welcome = () => (
  <IntroWrapper size="medium">
    <h3>Welcome to Pulse!</h3>
    <p>Ready to create amazing montages? Let's get started!</p>
  </IntroWrapper>
);

const MontageEditor = () => (
  <IntroWrapper size="medium">
    <h3>Pulse is a Montage Editor</h3>
    <p>Discover how Pulse helps you transform your media into stunning montages.</p>
  </IntroWrapper>
);

const Objectives = () => (
  <IntroWrapper size="medium">
    <h3>What you can do with Pulse</h3>
    <ol>
      <li>Create amazing montages in minutes</li>
      <li>Perfectly cut your clips to the music beats</li>
      <li>Reduce editing time with an innovative and streamlined workflow</li>
    </ol>
    <p>Take a few minutes to read through this page and learn about montages.</p>
    <p>
      <i>
        When you have finished, check out the amazing ones created with Pulse on our
        <a href="https://www.youtube.com/@ReflectPulse-Alpha" target="_blank">
          {' '}
          Pulse Alpha Channel
        </a>
        .
      </i>
    </p>
  </IntroWrapper>
);

const Ready = () => (
  <IntroWrapper>
    <h3>Let's Go!</h3>
    <p>Ready to create your first montage? Head to Projects to get started!</p>
  </IntroWrapper>
);

export const STEPS_PULSE = [
  { intro: <Welcome /> },
  { element: `[data-intro="${IntroKeys.intro}"]`, intro: <MontageEditor /> },
  { intro: <Objectives /> },
  { element: `[data-intro="${IntroKeys.navProjects}"]`, intro: <Ready /> },
];
